module.exports = __webpack_public_path__ + "static/media/KOREA.58da942e.jpg";